export default "__VITE_ASSET__Cx8$t1Ie__"